//@ts-nocheck
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import GameRules from "../../GameRules";
import Background from "../../SlotMachine/components/Background/Background";
import Header from "../../SlotMachine/components/Header/Header";
import PoweredByBik from "../../SlotMachine/components/PowereByBik/PoweredByBik";
import Title from "../../SlotMachine/components/Title/Title";
import SVGFactory, { SVGName } from "../../svgFactory";

import "./CouponPage.css";
const CouponPage = () => {
  const location = useLocation();
  const [copySVG, setCopySVG] = useState(SVGName.COPY);
  const [showGameRules, setShowGameRules] = useState<boolean>(false);
  const [redirectTime, setRedirectTime] = useState(5);
  const copyHandle = () => {
    const cb = navigator.clipboard;
    cb.writeText(location.state.couponCode).then(() => {
      setCopySVG(SVGName.CHECK);
    });
  };

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-666593854/j5cbCOa12ZMYEL7U7b0C",
      });
    }
    startTimer();
  }, []);

  const startTimer = () => {
    let intervalTimer = false;
    let timeoutInterval = false;
    timeoutInterval = setTimeout(() => {
      if (intervalTimer) {
        clearInterval(intervalTimer);
      }
      if (timeoutInterval) {
        clearTimeout(timeoutInterval);
      }
      redirectToStoreHandle();
    }, 5000);
    intervalTimer = setInterval(() => {
      setRedirectTime((old) => old - 1);
    }, 1000);
  };

  useEffect(() => {
    localStorage.removeItem("isAuthenticated");
  }, []);

  const redirectToStoreHandle = () => {
    window.open(
      "https://shoppersstop.onelink.me/Lgtb?pid=Gamification&is_retargeting=true&af_click_lookback=7d&af_ec=1&af_dp=com.shoppersstop://&utm_source=BIK&utm_medium=games&utm_campaign=SPIN-THE-WHEEL-Main-Page-110423&c=SPIN-THE-WHEEL-Main-Page-110423&af_web_dp=https%3A%2F%2Fwww.shoppersstop.com&af_ios_url=https%3A%2F%2Fwww.shoppersstop.com&af_android_url=https%3A%2F%2Fwww.shoppersstop.com&deep_link_value=https%3A%2F%2Fwww.shoppersstop.com%2Fcustom-page%2Fhome_page_1",
      "_top"
    );
  };

  const onUpadteShowGameRulesState = (flag: boolean) => {
    setShowGameRules(flag)
  }

  return (
    <Background>
      <Header />
      <div className="bik-sm-coupon-main-container">
        <SVGFactory name={SVGName.CONFETTI_VALENTINE} />
        <Title
          title={location?.state?.description}
          titleContainerStyle={{ marginBottom: 0 }}
        />
        <div className="bik-sm-couponcode-container">
          <p>Code: {location?.state?.couponCode}</p>
          <div onClick={copyHandle}>
            <SVGFactory name={copySVG} />
          </div>
        </div>
        <p
          style={{ color: "#646464" }}
        >{`Redirecting in 0${redirectTime} secs`}</p>
      </div>
      <PoweredByBik onTandCClickHandle={onUpadteShowGameRulesState} />
      {showGameRules && <GameRules onCloseHandle={onUpadteShowGameRulesState} />}
    </Background>
  );
};
export default CouponPage;
